import { System } from "@common/declarations";
import { type I18n } from "@common/lib/i18n";
import getOptions from "@common/lib/options";

export const fields = (() => {
  let systemContactProfilePromise: Promise<System.Api.FormFieldOptionItem[]>;
  const getSystemContactProfile = (i18n: I18n) => {
    if (!systemContactProfilePromise) {
      systemContactProfilePromise = getOptions(i18n).getCustomOptions<System.Api.FormFieldOptionItem>(
        "system",
        "formFields",
        {
          formFieldTypeKey: "ContactProfile",
          isSystem: true
        }
      );
    }
    return systemContactProfilePromise;
  };

  return {
    getContactProfileEmailId: async (i18n: I18n) => {
      const fields = await getSystemContactProfile(i18n);

      return fields.find((x) => x.formFieldKey === "Email")!.value;
    }
  };
})();
